// extracted by mini-css-extract-plugin
export default {"productGallery":"HK-z","inQuickShop":"IK-z"};